import { l, p, lMini } from "./content";
const offers = [
  {
    id: 1,
    title: "Билеты от 499 рублей!",
    text:
      "Билеты от 499 рублей! \n Специальное предложение от авиакомпании Победа",
    logo: p,
    price: "499",
    timeLeft: "45",
    miniLogo: ""
  },
  {
    id: 2,
    title: "В Нью-Йорк от 20 680 Р",
    text:
      "Из Москвы в США от 20680 рублей! Специальное предложение от авиакомпании Lufthansa",
    logo: l,
    price: "20 680",
    timeLeft: "28",
    miniLogo: lMini
  },
  {
    id: 3,
    title: "В Лос-Анджелес от 22 360 Р",
    text:
      "Из Москвы в США от 22360 рублей! Специальное предложение от авиакомпании Lufthansa",
    logo: l,
    price: "22 360",
    timeLeft: "19",
    miniLogo: lMini
  }
];
export default offers;
